import { useEffect, useRef, useState } from 'react';
import './WorkflowHeader.css';
import MasterComponentWraper from '../../../components/Backend/MasterComponentWraper';
import NavigationHeder from '../../../components/Navigations/NavigationHeder'; 
import DropDownInput from '../../../components/Forms/Dropdown'; 
import PaginatedDropdown from '../../../components/Forms/PaginatedDropdown'; 
import CustomHtmlCell from '../../../components/grid/ag/cellRender/CustomHtmlCell';
import DatepickerFunctions from '../../../inc/DatepickerHelper';
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings'; 
import WorkflowOffCanvas from './WorkflowOffCanvas';
import AgGridNew from '../../../components/grid/ag/ag-grid-new'; 
import { getOptions, gridRFQExpireFormat, optionsKeyCreator, taskStatusLabelValueFormat } from '../../../components/grid/ag/commonFunctions/GridCommonFunctions';
import ExportDataPopup from './ExportDataPopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShuffle } from '@fortawesome/free-solid-svg-icons';
import { checkIfArrayIsEmpty } from '../../../inc/Validation';
import RefreshGridBtn from '../../../components/inc/RefreshGridBtn';
import Helper from '../../../inc/Helper';
import Collapse from '../../../components/inc/Collapse';

let currentSearchTermUser = '';
let sourcesAPICalled = false; 
let gridApi = null; 
const WorkflowPendingTasks = () => { 
  const [sources, setSources] = useState([]);

  const [gridForceRender, setGridForceRender] = useState(1);
  const [workflowFetchTasksDetails, setWorkflowFetchTasksDetails] = useState({});
  
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [showCanvas, setShowCanvas] = useState(false);
  const [exportDataDetails, setExportDataDetails] = useState({
    openPopup: false,
    apiPayload: {},
    apiColumnHeaders: []
  });

  const [workflowRecallTasks, setWorkflowRecallTasks] = useState({
    module_id: null, 
    workflow_name: null,
    stage: null,
    task_assignee_name: null,
    initiated_date: null
  });

  const usersDataRef = useRef([]);
  
  useEffect(() => {
    getSystemSources();
  }, []);

  const getSystemSources = () => {
    let api = Api
    api.setUserToken()
    api.axios().get(Settings.apiUrl+'/source',{}).then(function(res){
      if(res.data.status==='success'){
        setSources(res?.data?.data
          ?.filter((item) => Settings.workflow_documents_sources.includes(item.source_id))
          ?.map((item) => {
          return {
            value: item.source_id,
            label: item.source_name
          }
        })) 
      } 
    })
  };

  const displayRecallBtn = () => { 
    return `<div style="background-color: #12BDB21C" class="rs_active_label_actions">Recall Workflow</div>`;
  };

  const onCellClickHandler = (event) => {
    const { module_id, workflow_name, stage, task_state, task_assignee_name, initiated_date, instance_task_id } = event?.data;
 
    if (event.colDef.field === 'recall') {
      if(Object.values(task_state)[0] == "Completed"){
        Helper.alert('Only incomplete tasks can be recalled', 'error');
        return;
      };

      setShowCanvas(true);
      setWorkflowRecallTasks({
        module_id: module_id,
        workflow_name: workflow_name,
        stage: stage,
        task_assignee_name: task_assignee_name,
        initiated_date: initiated_date,
        instance_task_id: instance_task_id
      });
    };
  };

  const onSelectionChanged = (event) => {
    let selectedRows = event?.api?.getSelectedRows();
    setSelectedTasks(selectedRows);
  };

  const getStatusColor = (status) => {
    if (typeof status !== 'string') {
      return '-';
    };
    
    if(status){  
      switch (status?.toLowerCase()) {
        case 'vendor':
          return '#12BDB21C'
        case 'purchase requisition':
          return '#8239BC1C'
        case 'rfi/ro purchase requisition':
          return '#8239BC1C'
        case 'purchase order':
          return '#54A0CA1C'
        case 'purchase agreement':
          return '#54A0CA1C'
        case 'rate card/item catalogue':
          return '#54A0CA1C'
        case 'good receiving':
          return '#ECF5F9'
        case 'contract':
          return '#FBB5001C'
        case 'direct order':
          return '#54A0CA1C' 
        case 'awarding':
          return '#9002021C'
        case 'auction awarding':
          return '#9002021C'
        case 'auction line':
          return '#9002021C'
        case 'auction line distribution':
          return '#9002021C'
        case 'request for quotation':
          return '#54A0CA1C' 
        case 'auction':
          return '#54A0CA1C'
        case 'rfi technical evaluation':
          return '#54A0CA1C'
        case 'rfq technical evaluation':
          return '#54A0CA1C'
        case 'rfq financial evaluation':
          return '#54A0CA1C'
        case 'rfi financial evaluation':
          return '#54A0CA1C'
        case 'auction financial evaluation':
          return '#54A0CA1C'
        case 'rfq commercial evaluation':
          return '#54A0CA1C'
        case 'rfq awarding':
          return '#54A0CA1C'
        case 'rfi awarding':
          return '#54A0CA1C'
        case 'request for information':
          return '#54A0CA1C'
        case 'bom':
          return '#9002021C'
        case 'invoice':
          return '#FBB5001C'
        case 'return order':
          return '#54A0CA1C'
        case 'work confirmation':
          return '#54A0CA1C'
        case 'purchase order-amendment':
          return "#9002021C"
        case 'settlement':
          return "#54A0CA1C"
        case 'advance shipment notice':
          return "#8239BC1C"
        default:
          return '#9002021C' 
      };
    };
    // more will be added as per the implementations of workflow system,
  };

  const gridLinkValueFormat = (params) => {   
    const sourceLabel = !checkIfArrayIsEmpty(sources) ? (sources?.find((id) => id.value === params.value) !== undefined ? sources?.find((id) => id.value === params.value)?.label : '') : params?.value;  
    return `<div style="background-color: ${getStatusColor(params?.value == 54 ? sourceLabel?.split(',')[2].trim() : sourceLabel)}" class="rs_active_label_actions">${params?.value == 54 ? sourceLabel?.split(',')[2].trim() : sourceLabel}</div>`
  };
  
  const mapUsersData = (item) => {
    return {
      text: `${item.first_name} ${item.last_name}`,
      id: item.user_id
    };
  };

  const reloadGrid = () => {
    gridApi?.refreshServerSide({ purge: true });
    gridApi?.deselectAll();
  };
  
  const gridColHeaders = [
    { field:'document_number', valueFormatter: (params) => (params?.value ?? '-'), minWidth: 280, headerName: "Document number", editable: false },
    { field:'initiated_by_name', minWidth: 280, headerName: "Requester", editable: false },
    { field:'initiated_date', valueFormatter: (params) => DatepickerFunctions.convertDateFromDataBase(params?.value), minWidth: 280, headerName: "Date", editable: false },
    { field:'assigned_by_name', minWidth: 280, headerName: "From", editable: false },
    { field:'due_date',  cellRenderer: (params) => gridRFQExpireFormat(params, false), minWidth: 280, headerName: "Due date", editable: false},
    { 
      field: 'module_id', 
      headerName: 'Source',
      editable: false, 
      isAllowZero: true,
      sortable: false,
      minWidth: 280, 
      cellEditorParams: { values: sources },
      cellDataType:false,
      valueFormatter: gridLinkValueFormat,  
      cellRenderer: CustomHtmlCell, 
      filter:'agSetColumnFilter',
      filterParams: {
        values: (params) => getOptions(params, sources),
        keyCreator: (params) => optionsKeyCreator(params, 'value'),
        valueFormatter: params => params.value.label
      }
    },
    { field:'task_state', filter: 'agSetColumnFilter', filterParams: {  values: ['1', '0'], keyCreator: (params) => params.value, valueFormatter: (params) => params.value == '1' ? 'Completed' : 'In Completed' }, minWidth: 280, headerName: "Task status", cellRenderer: (params) => taskStatusLabelValueFormat(params) },
    { field:'recall', minWidth: 280, headerName: "Action", valueFormatter: displayRecallBtn, cellRenderer: CustomHtmlCell, filter: false, sortable: false, editable: false }
  ];

  const onReAssignClick = () => {
    if(selectedTasks?.length === 0) return;

    const hasCompletedTask = selectedTasks?.some(task => {
      const state = task?.task_state;
      return state?.[1] === "Completed";
    });

    if (hasCompletedTask) {
      Helper.alert('Select only incomplete tasks for reassigning', 'error');
      return;
    };

    setShowCanvas(true);
  };

  const exportData = async () => {
    setExportDataDetails({
      openPopup: true,
      apiPayload: {
        task_type: workflowFetchTasksDetails?.task_type,
        for_workflow: true,
        user_id: workflowFetchTasksDetails?.user_id !== "" ? workflowFetchTasksDetails?.user_id : null
      }, 
      apiColumnHeaders: [
        "document_number",
        "initiated_by_name",
        "initiated_date",
        "assigned_by_name",
        "due_date",
        "module_id"
      ]
    });
  };

  const disableApiCalls = (!workflowFetchTasksDetails?.task_type || workflowFetchTasksDetails?.task_type === "" || workflowFetchTasksDetails?.task_type === undefined);
  return (
    <div className='container-fluid'> 
      {exportDataDetails?.openPopup ? 
        <ExportDataPopup 
          apiUrl={Settings.apiUrl + `/workflow/pending_actions`} 
          apiPayload={exportDataDetails?.apiPayload}
          apiColumnHeaders={exportDataDetails?.apiColumnHeaders}
          setExportDataDetails={setExportDataDetails} 
        /> 
      : null}

      <NavigationHeder
        hideBackButton={true}
        title={`<span style="color:#000;"> Home > </span>  ${"Workflow Pending Tasks"}`}
      />

      <Collapse title={"Workflow Task Filters"} className='mb-4' open={true}>
        <div className="row">
          <div className='col-lg-3'>  
            <PaginatedDropdown
              options={[]} 
              pagination={true}
              apiUrl={Settings.apiUrl + `/user`}
              additionalParams={{user_type:0,adv_search:`[{"conditions":"AND","filters":[{"left":"enable","right":[true],"operation":"set"}]}]`}} 
              currentSearchTerm={currentSearchTermUser}
              allDataRef={usersDataRef}
              mapFunction={mapUsersData}
              reRenderRequired={true}
              placeHolder={"Select user"} 
              label={'User'}
              id="user_id"
              onChange={(evt) => {
                setWorkflowFetchTasksDetails((prevState) => {
                  return {
                    ...prevState,
                    user_id: evt.target.value
                  }
                })
                setGridForceRender(prevState => prevState + 1);
                setSelectedTasks([]);
              }}
              value={workflowFetchTasksDetails?.user_id}
            /> 
          </div>

          <div className='col-lg-3'>  
            <DropDownInput
              options={ 
                Settings.enum_workflow_data.instance_state
              }
              required={true}
              reRenderRequired={true}
              placeHolder={"Select task type"} 
              label={'Task type'}
              id="task_type"
              onChange={(evt) => {
                setWorkflowFetchTasksDetails((prevState) => {
                  return {
                    ...prevState,
                    task_type: evt.target.value
                  }
                })
                setGridForceRender(prevState => prevState + 1);
                setSelectedTasks([]);
              }}
              value={workflowFetchTasksDetails?.task_type}
            /> 
          </div> 
        </div>
      </Collapse>

      <AgGridNew 
        pagination={true} 
        apiUrl={Settings.apiUrl + `/workflow/pending_actions`} 
        payload={{
          task_type: workflowFetchTasksDetails?.task_type,
          for_workflow: true,
          user_id: workflowFetchTasksDetails?.user_id !== "" ? workflowFetchTasksDetails?.user_id : null
        }}
        returnApiCondition={disableApiCalls}
        apiMethod={"post"}
        key={gridForceRender}
        columnDefs={gridColHeaders} 
        onSelectionChanged={onSelectionChanged}
        onCellClicked={onCellClickHandler}
        hideDeleteBtn={true} 
        hideAddBtn={true}
        btnsWrapperStyle="w-100"
        afterDeleteBtns={
          <div className="d-flex align-items-center w-100">
            <div className="d-flex ms-auto align-items-center">
              <div className="import_sample_template">
                <button 
                  onClick={onReAssignClick}
                  disabled={selectedTasks?.length === 0}
                  className={`rs_h_controller rs_setvalue_btn visible_on_select_item ${selectedTasks?.length === 0 ? 'ctl-dissable' : ''}`}
                >
                  <FontAwesomeIcon icon={faShuffle} />
                  Re-assign Action
                </button>
              </div>

              <div className="import_sample_template">
                <button onClick={exportData}>
                  <img className="img-fluid" src="/images/icons/excel-logo.svg" alt="excel-logo" />
                  Export
                </button>
              </div>

              <div className="me-3">
                <RefreshGridBtn onClickRefreshBtn={reloadGrid} />
              </div>
            </div>
          </div>
        }
        height={500} 
        onGridReady={(params) => gridApi = params?.api} 
        gridId={'grid_workflow_pending_tasks'}
        headerCheckboxSelection={false}
      />

      {showCanvas &&
        <WorkflowOffCanvas
          isOpen={showCanvas}
          sources={sources}
          type={
            workflowRecallTasks?.module_id ? 
            { label: Settings.enum_workflow_data.task_types_recall.name, value: Settings.enum_workflow_data.task_types_recall.id } : 
            { label: Settings.enum_workflow_data.task_types_reassign.name, value: Settings.enum_workflow_data.task_types_reassign.id }
          }
          closeSidebar={setShowCanvas}
          reloadFunction={reloadGrid}
          workflowReAssignTasks={selectedTasks}
          workFlowActionObject={{
            workflow_name: workflowRecallTasks?.workflow_name,
            stage: workflowRecallTasks?.stage,
            task_assignee_name: workflowRecallTasks?.task_assignee_name,
            initiated_date: workflowRecallTasks?.initiated_date,
            instance_task_id: workflowRecallTasks?.instance_task_id,
            user_id: workflowFetchTasksDetails?.user_id
          }}
          setWorkFlowActionObject={setWorkflowRecallTasks}
          source_id={workflowRecallTasks?.module_id} 
        />
      } 
    </div>
  );
}

export default (MasterComponentWraper(WorkflowPendingTasks));